import { isNotNilOrEmpty } from '@@serverHelpers';
import { dateTsToFr } from '@@viewHelpers/date';
import { evolve, modifyPath, when } from 'ramda';
import moment from 'moment';

export const formatExtraDefaultValues = modifyPath(
  ['company', 'creationDate'],
  when(isNotNilOrEmpty, dateTsToFr));

const frDateToDate = (date) => {
  if (date instanceof Date) return date;
  const m = moment(date, 'DD/MM/YYYY', true);
  return m.isValid() ? m.toDate() : null;
};

export const formatExtraDataBeforeSubmit = evolve({
  company: when(isNotNilOrEmpty, evolve({
    creationDate: when(isNotNilOrEmpty, frDateToDate)
  }))
});
